import React from 'react';
import { Link } from 'react-router';

export default class Main extends React.Component {

	componentWillMount() {
	}

	render() {
		return (
			<div className="container Welcome-box cs-card">
				<div className="row align-items-start">
					<div className="col-sm-4 grid-logo-container">
						<img src="/vale_logo.png" className="logo-partners vale-logo" ></img>
					</div>

					<div className="col-sm-4">
						<img src="/coppeteclogo.png" className="logo-partners coppetec-logo" ></img>
					</div>
					<div className="col-sm-4">
						<img src="/coppelogo.png" className="logo-partners" ></img>
					</div>
				</div>

				<hr />
				<div className="Welcome-title">
						Bem Vindo ao Repositório Dinâmico de Documentos Georreferenciados.
				</div>
				<div className="grid-container">

					<div to="" className="item-icon1 item-iconMargin icon-iconCadastrar">
						<img src="/create_icon.png" className="center iconCadastrar" />
						<div className="overlayCadastrar">
							<div className="centralizeButtons">
								<br></br>
								<Link to="/admin/documents/create/mariana" 
								className="testeClassMultimidia" >  Mariana </Link>
								<br></br>
								<Link to="/admin/documents/create/brumadinho" 
								className="testeClassMultimidia" > Brumadinho </Link>
							</div>
						</div>
					</div>

					<Link to="/admin/documents/view" className="item-icon2 item-iconMargin">
						<img src="/documents_icon.png" className="center" />
					</Link>

					<div to="" className="item-icon3 item-iconMargin icon-iconMultimidia">
						<img src="/multimedia_icon.png" className="center iconMultimidia" />
						<div className="overlayMultimidia">
							<div className="centralizeButtons">
								<br></br>
								<Link to="/admin/multimidia/mariana" 
								className=" testeClassMultimidia " > Mariana </Link>
								<br></br>
								{/* &#xf1c8;  */}
								<Link to="/admin/multimidia/brumadinho" 
								className="brumadinhoMultimidia " > Brumadinho </Link>
							</div>
						</div>
					</div>

					<Link to="/admin/documents/explorer" className="item-icon4 item-iconMargin">
						<img src="/GIS_icon.png" className="center" />
					</Link>

					<Link to="/admin/documents/ftp" className="item-icon5 item-iconMargin">
						<img src="/FTP_icon.png" className="center" />
					</Link>

					<Link to="/admin/manual" className="item-icon6 item-iconMargin" >
						<img src="/manual_icon.png" className="center" />
					</Link>

					<text className="item-text1" >Cadastrar</text>
					<text className="item-text2" >Documentos</text>
					<text className="item-text3" >Multimídia</text>
					<text className="item-text4" >GIS</text>
					<text className="item-text5" >Arquivos</text>
					<text className="item-text6" >Manual</text>
				</div>

				<div className="Welcome-subtitle">
						O Projeto
				</div>
				<hr className="Welcome-divider" />
				<div>
					<p>
						A avaliação dos impactos da ruptura da barragem de rejeitos
						de fundão é um projeto que esta sendo desenvolvido para a
						empresa Vale S.A. em duas fases. A primeira fase da avaliação
						ocorreu 9 meses após o acidente e a segunda, 36 meses depois.
						Além de envolver o esforço da integração de uma equipe
						multidisciplinar abrange também a seleção, análise e interpretação
						de um grande volume de documentos provenientes de diferentes fontes
						e bancos de dados. A criação do Repositório Dinâmico de Documentos
						Georreferenciados – GeoDocs tem o objetivo de oferecer um sistema
						para o cadastro e gestão eletrônica de documentos georreferenciados,
						visando a organização e o compartilhamento dos documentos inventariados
						e produzidos por pesquisadores da COPPE. Estes documentos incluem textos,
						planilhas, fotos, mapas e outras mídias georreferenciadas que, uma vez organizados,
						poderão ser consultados e editados, de forma colaborativa, pelos usuários do sistema.
					</p>
				</div>
				<div className="Welcome-subtitle">
						Recursos Disponíveis
				</div>
				<hr className="Welcome-divider" />
				<div>
					<p>
						A plataforma oferece ferramentas customizadas para o cadastro e gestão eletrônica de
						documentos georreferenciados, visando a organização e o compartilhamento dos documentos
						inventariados e produzidos por pesquisadores da COPPE. Estes documentos uma vez
						organizados poderão ser editados e consultados, incluindo a busca por filtros (como por
						exemplo: palavras-chave) ou espacial (geográfica) sendo possível a exportação dos documentos
						selecionados.
					</p>
				</div>
				<div className="Welcome-subtitle">
						Equipe de Desenvolvimento
				</div>
				<hr className="Welcome-divider" />
				<div>
					<p>
						O Repositório Dinâmico de Documentos Georreferenciados – GeoDocs esta sendo
						desenvolvido pelo LABgccbd – Laboratório de Gestão do Conhecimento, Colaboração,
						e Banco de Dados do Programa de Engenharia de Sistemas e Computação –
						PESC/COPPE/UFRJ em parceria com a Escola Nacional de Ciências Estatísticas – ENCE,
						sob a coordenação dos Profs. Jano Moreira de Souza e Geraldo Zimbrão da Silva.
					</p>
				</div>
				<div className="container">
					<div className="row">
						<div className="col-">
							<p>1ª Fase</p>
							<p></p>
							<ul>
								<li>Jano Moreira de Souza</li>
								<li>Geraldo Zimbrão da Silva</li>
								<li>Maria Gilda P. Esteves</li>
								<li>Julia Strauch</li>
								<li>Cafer Cruz</li>
								<li>Daniel Souza Rechtman</li>
								<li>David Schechtman</li>
								<li>Felipe Nóbrega</li>
								<li>Rafael Gonçalves dos Santos Quintanilha</li>
								<li>Renato Lopes</li>
							</ul>
						</div>
						<div className="col-">
							<p>2ª Fase</p>
							<p></p>
							<ul>
								<li>Jano Moreira de Souza</li>
								<li>Geraldo Zimbrão da Silva</li>
								<li>Maria Gilda P. Esteves</li>
								<li>Julia Strauch</li>
								<li>Alonso Matos do Amparo Neto</li>
								<li>João Victor da Conceição Miranda</li>
								<li>Raphael Gil Soares Ferreira</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Welcome/Main.js